// import Vue from 'vue'
// import './assets/tailwind.css'
// import App from './App'
// import router from './router'
// import '@/components/globalComponent.js'

// Vue.config.productionTip = false

// new Vue({
//   router,
//   render: h => h(App)
// }).$mount('#app')

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import './assets/tailwind.css'
import App from './App'
import router from './router'
import '@/components/globalComponent.js'

// import axios from 'axios'
// Vue.prototype.$axios = axios
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App, Headers},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js